import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const ClientGroupingUrl = `${Base_Url}/ClientGroup`;

export const GetClientGroupList = async (params) => {
  const res = await postApiWithAuthorization(
    `${ClientGroupingUrl}/GetClientGroupList`,
    params
  );
  return res;
};

export const AddUpdateClientGroup = async (params) => {
  const res = await postApiWithAuthorization(
    `${ClientGroupingUrl}/AddUpdateClientGroup?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetClientGroupModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ClientGroupingUrl}/GetClientGroupModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&ClientGroupKeyID=${KeyID}`
  );
  return res;
};

export const ChangeClientGroupStatus = async (
  ModuleName,
  KeyID,
  adminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${ClientGroupingUrl}/ChangeClientGroupStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&ClientGroupKeyID=${KeyID}`
  );
  return res;
};

export const DeleteClientGroup = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${ClientGroupingUrl}/DeleteClientGroup?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&ClientGroupKeyID=${KeyID}`
  );
  return res;
};
